import React from "react";
import { Spinner } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

function Loader() {
    const { t } = useTranslation();
    return (
        <div className="loader">
            <Spinner 
                animation="border" 
                role="status"
                style={{ width: '100px', height: '100px', margin: 'auto', display: 'block' }}
            >
                <span className="sr-only">{t('common.loading')}</span>
            </Spinner>
        </div>
    );
}

export default Loader;
